import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  status: "loading",
  error: ""
};

const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    setLicense: (state, action) => {
      state.data = action.payload ?? null;
      state.status = "ready";
      state.error = "";
    },
    setLicenseError: (state, action) => {
      state.data = null;
      state.status = "error";
      state.error = action.payload || "Не удалось загрузить лицензию";
    }
  }
});

export const { setLicense, setLicenseError } = licenseSlice.actions;

export default licenseSlice.reducer;
